var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.047 29.43l-5.238.241c-3.187-2.23-5.022-4.526-5.805-7.799l1.7-4.968-1.099-5.05-4.639-.68c-1.394-.205-2.661.787-2.655 2.196.016 3.519.634 9.985 4.46 15.123 4.016 5.396 10.495 8.431 14.106 9.79 1.395.524 2.838-.412 3.054-1.887l.65-4.433-4.534-2.533z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default __webpack_public_path__ + "a78da25bdeb8c1e39b3965110a9676b0.svg";
export { SvgPhoneCircle as ReactComponent };